import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-36479cc5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "operate-wrap" }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 0,
  class: "operte-innder-wrap"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "operate-text" }

import moreArrow from '@/assets/malfunction-repair/right-green-arrow.png'
import { ref, onMounted, onUnmounted,withDefaults, computed } from 'vue'
import type { CSSProperties } from 'vue'
export type ListItem = {
  id: string
  text: string,
  judgeItemShow: Boolean,
  style?: CSSProperties
  clickHandle?: () => void
}



export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    list: null
  },
  setup(__props: any) {

const props = __props as { list: Array<ListItem> };



let gotoEvaluateItem = computed(() => {
  return props.list.find(item => item.id === 'gotoEvaluate')
})

let cancelItem = computed(() => {
  return props.list.find(item => item.id === 'cancel')
})

let viewEvaluateItem = computed(() => {
  return props.list.find(item => item.id === 'viewEvaluate')
})
let applyTechnicalSupportItem = computed(() => {
  return props.list.find(item => item.id === 'applyTechnicalSupport')
})


let isShowGotoEvaluate = computed(() => {
  return props.list.find(item => item.id === 'gotoEvaluate' && item.judgeItemShow) && listComputed.value.length === 1
})

let isShowViewEvaluate = computed(() => {
  return props.list.find(item => item.id === 'viewEvaluate' && item.judgeItemShow) && listComputed.value.length === 1
})

let isShowCancelBtn = computed(() => {
  return props.list.find(item => item.id === 'cancel' && item.judgeItemShow) && listComputed.value.length === 1
})


let isShowApplyTechnicalSupport = computed(() => {
  return props.list.find(item => item.id === 'applyTechnicalSupport' && item.judgeItemShow) && listComputed.value.length === 1
})


let listComputed = computed(() => {
  return props.list.filter(item => item.judgeItemShow)

})

let isMenuShow = ref(false)
const moreBtnWrap = ref<HTMLElement | null>(null)
function moreHandle () {
  isMenuShow.value= true
}

// 点击外部关闭菜单的处理函数
function handleClickOutside(event: MouseEvent | TouchEvent) {

  if (moreBtnWrap.value && !moreBtnWrap.value?.contains(event.target as Node)) {
    isMenuShow.value = false
  }
}

// 组件挂载时添加事件监听
onMounted(() => {
  document.addEventListener('click', handleClickOutside)
})

// 组件卸载时移除事件监听
onUnmounted(() => {
  document.removeEventListener('click', handleClickOutside)
})


// 组件挂载时添加事件监听
onMounted(() => {
  document.addEventListener('touchstart', handleClickOutside)
})

// 组件卸载时移除事件监听
onUnmounted(() => {
  document.removeEventListener('touchstart', handleClickOutside)
})


function clickHandle (item: ListItem) {
  isMenuShow.value = false
  if (item && item.clickHandle) {
    item.clickHandle()
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(listComputed).length >1)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "more-btn-wrap",
          ref_key: "moreBtnWrap",
          ref: moreBtnWrap
        }, [
          _createElementVNode("div", {
            class: "more-text",
            onClick: moreHandle
          }, "更多"),
          _createElementVNode("img", {
            width: "16",
            height: "16",
            class: "more-arrow",
            src: _unref(moreArrow)
          }, null, 8, _hoisted_2),
          (_unref(isMenuShow))
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(listComputed), (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "operate-item",
                    key: item.text,
                    style: _normalizeStyle(item.style),
                    onClick: ($event: any) => (clickHandle(item))
                  }, [
                    _createElementVNode("div", _hoisted_5, _toDisplayString(item.text), 1)
                  ], 12, _hoisted_4))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ], 512))
      : _createCommentVNode("", true),
    (_unref(isShowCancelBtn))
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "cancel-button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (clickHandle(_unref(cancelItem))))
        }, "取消单据"))
      : _createCommentVNode("", true),
    (_unref(isShowGotoEvaluate))
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: "evaluate-button",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (clickHandle(_unref(gotoEvaluateItem))))
        }, "前往评价"))
      : _createCommentVNode("", true),
    (_unref(isShowViewEvaluate))
      ? (_openBlock(), _createElementBlock("div", {
          key: 3,
          class: "evaluate-button",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (clickHandle(_unref(viewEvaluateItem))))
        }, "查看评价"))
      : _createCommentVNode("", true),
    (_unref(isShowApplyTechnicalSupport))
      ? (_openBlock(), _createElementBlock("div", {
          key: 4,
          class: "evaluate-button",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (clickHandle(_unref(applyTechnicalSupportItem))))
        }, "申请技术支持"))
      : _createCommentVNode("", true)
  ]))
}
}

})